import {
  InlineError$PunishAfterEditing,
  InlineError$PunishBeforeSubmitting,
  InlineError$PunishWhileEditing,
} from "@/modules/form-field/errors";
import { useField$Text } from "@/modules/form-field/hooks/useField$Text";

type Params = {
  numEditions: number | undefined;
};

function textToValue(text: string, params: Params): number {
  text = text.replace(/[\s]/g, ""); // preprocessing: remove all spaces

  InlineError$PunishBeforeSubmitting.assert(
    //
    text,
    "This field is required"
  );

  InlineError$PunishWhileEditing.assert(
    /^[0-9.+-]*$/.test(text),
    "Invalid characters"
  );

  InlineError$PunishWhileEditing.assert(
    /^[0-9]*$/.test(text),
    "Must be a non-negative integer"
  );

  const value = Number(text);

  InlineError$PunishAfterEditing.assert(
    params.numEditions == null || value <= params.numEditions,
    `Cannot be more than ${params.numEditions}, which is the total number of editions`
  );

  return value;
}

function valueToText(value: number, _params: Params): string {
  return value.toString();
}

export const useFieldNumMinting = useField$Text.withConfig<number, Params>({
  getInitialText: () => "0",
  valueToText,
  textToValue,
});
